import { getCurrentInstance } from 'vue';

export const useEventBus = () => {
  const internalInstance = getCurrentInstance();
  if (!internalInstance) {
    throw new Error('useEventBus must be called within a setup function');
  }

  return internalInstance.appContext.config.globalProperties.eventBus;
};
